/**
 * Redux actions for testarrosa
 * @module services/testarossa/redux/actions
 */

export const SET_TESTAROSSA_PROJECTS_PROCESSING = 'SET_TESTAROSSA_PROJECTS_PROCESSING'
export const SET_TESTAROSSA_PROJECTS_ERROR = 'SET_TESTAROSSA_PROJECTS_ERROR'
export const GET_TESTAROSSA_PROJECTS = 'GET_TESTAROSSA_PROJECTS'
export const GET_TESTAROSSA_PROJECT_CAMPAIGNS = 'GET_TESTAROSSA_PROJECT_CAMPAIGNS'
export const SET_TESTAROSSA_PROJECTS_DATA = 'SET_TESTAROSSA_PROJECTS_DATA'
export const GET_TESTAROSSA_PROJECT = 'GET_TESTAROSSA_PROJECT'
export const SET_TESTAROSSA_CAMPAIGNS_ERROR = 'SET_TESTAROSSA_CAMPAIGNS_ERROR'
export const GET_TESTAROSSA_CAMPAIGN = 'GET_TESTAROSSA_CAMPAIGN'
export const SET_TESTAROSSA_CAMPAIGN_DATA = 'SET_TESTAROSSA_CAMPAIGN_DATA'

/**
 * Get one testarossa campaign
 * @param {Object} options The options
 * @param {String} options.uuid The campaign uuid
 */
export function getTestarossaCampaign ({ uuid } = {}) {
  return {
    type: GET_TESTAROSSA_CAMPAIGN,
    payload: { uuid },
  }
}
